import PropTypes from 'prop-types';
import './Dot.css';

const Dot = ({
  dotIndex,
  currentIndex,
  dotSize,
  onDotClick = () => {},
}) => {
  const style = {
    width: `${dotSize}px`,
    height: `${dotSize}px`,
    cursor: 'pointer',
    borderRadius: '50%',
    marginRight: '5px',
    backgroundColor: 'white',
  };

  if (dotIndex === currentIndex) {
    style.width = `${dotSize * 3}px`;
    style.borderRadius = '4px';
  }

  return <div className="dot" style={style} onClick={() => { onDotClick(dotIndex); }} />;
};

Dot.propTypes = {
  dotIndex: PropTypes.number,
  currentIndex: PropTypes.number,
  dotSize: PropTypes.number,
  onDotClick: PropTypes.func,
};

export default Dot;
